import { FC, useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Form as FinalForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import { Typography, Grid, IconButton, Button } from '@material-ui/core'

import useTranslate from '../../../i18n/useTranslate'
import arrayMutators from 'final-form-arrays'
import Select from '../../../control/select/select'
import Radio from '../../../control/radio/radio'
import MyCheckbox from '../../../control/checkbox/checkbox'
import useTitleName from '../../../services/um/lookups/useTitleName'
import useUsergroupFilterREC from '../../../services/um/lookups/useUsergroupFilterREC'
import useUserGroup from '../../../services/um/lookups/useUsergroup'

import useGroup from '../../../services/um/lookups/useGroup'
import usePosition from '../../../services/um/lookups/usePosition'
import FieldObservable from './FieldObservable'
import useEditUsergroup, { FormInitial, FormType } from '../../../services/um/useEditUsergroup'
import { Check, Clear, InfoOutlined } from '@material-ui/icons'
import { FormApi } from 'final-form'
import { spellWord } from '../../../utilities/email'
import UploadLogo from './UploadLogo'
import checkPermission from '../../../utilities/checkPermission'
import { validateEmail } from '../../../utilities/validate'
import ConstantUserGroup from '../../../constants/userGroup'
import * as _ from 'lodash'
import Tooltip from '../../../control/tooltip/tooltip'
import DialogSetPassword from './DialogSetPassword'
import UploadDocFile from '../../web/shareUI/uploadDoc/UploadDocFile'
import { useHistory, useParams } from 'react-router-dom'

interface FormProps {
    initialValue?: any
    initialValues?: any
    onClickSubmit: (values: FormType) => void
    onChangeMobilePhone: (value: string, fnCallback: (valBack: string) => void) => void
    onClickBackLink: () => void
    onCheck?: (username: string, cunet?: string) => void
    onInitialCUData?: (personnelId: string, form: FormApi<FormType, Partial<FormType>>) => void
    onChangeUsername?: () => void
    isChecked?: boolean | null
    onchangeRadioCUNET?: (form: FormApi<FormType, Partial<FormType>>) => void
    readonly?: boolean
    mode?: string
    topicInitial: any
    initialUploadFile: FormInitial['documentInfo']
}
type dataLookup = {
    id: number
    name_th: string
    name_en: string
}
export type InitFiles = {
    fileList: {
        replaceFileID: number | null
        fileID: string | null
        fileToken: string | null
        filename: string | null
        path: string
        date: string
    }[]
}
const Form: FC<FormProps> = ({
    onClickSubmit,
    onChangeMobilePhone,
    onClickBackLink,
    onCheck,
    isChecked,
    onChangeUsername,
    onchangeRadioCUNET,
    initialValue,
    readonly,
    mode,
    topicInitial,
    initialUploadFile,
}) => {
    const [lstFileUpload, setLstFileUpload] = useState<any>([])

    const classes = useStyles()
    const translate = useTranslate()
    const history = useHistory()
    const params = useParams<{ id: string }>()

    const { state } = useTitleName()
    const { userGroup } = useUserGroup()
    const { usergroupFilterREC } = useUsergroupFilterREC()
    const { officerInfo } = useEditUsergroup(`${params.id}`)

    const { group } = useGroup()
    const { position } = usePosition()
    const permissionHook = checkPermission()

    const userIRB = initialValue?.irb?.toString()
    const groupID = initialValue?.usergroupID?.toString()
    const titleID = initialValue?.titleID?.toString()
    const positionID = initialValue?.positionID?.toString()

    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const lookupTitleName = state.map((item: dataLookup) => {
        return {
            value: item.id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }
    })

    const lookupPosition = position.map((item: dataLookup) => {
        return {
            value: item.id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }
    })

    const lookupUserGroupInitial = userGroup
        .map((item: dataLookup) => {
            return {
                value: item.id.toString(),
                label: lang === 'en' ? item.name_en : item.name_th,
            }
        })
        .filter((itm) => itm.value === groupID)

    const lookupUserGroup = usergroupFilterREC
        .map((item: dataLookup) => {
            return {
                value: item.id.toString(),
                label: lang === 'en' ? item.name_en : item.name_th,
            }
        })
        .filter((item) => {
            if (groupID === ConstantUserGroup.researcher.toString()) {
                //ถ้า user เป็นนักวิจัยดูได้
                return item
            } else {
                //เจ้าหน้าที่เพิ่มนักวิจัยไม่ได้ ต้องสมัครมาเอง
                return item.value !== ConstantUserGroup.researcher.toString() && item
            }
        })

    const lookupGroup = group.map((item: { irb_id: number; name_th: string; name_en: string }) => {
        return {
            value: item.irb_id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }
    })

    const validateForm = (values: any) => {
        const errors: any = {}
        if (Number(values.usergroupID) === 3 || Number(values.usergroupID) === 6 || Number(values.usergroupID) === 7) {
            if (!values.signatureTH) {
                errors.signatureTH = `${translate.get('UM.UPLOAD.REQUIRED')}`
            }

            if (!values.signatureEN) {
                errors.signatureEN = `${translate.get('UM.UPLOAD.REQUIRED')}`
            }
        }

        return errors
    }

    const getDisableIRB = () => {
        let isDisableIRB = true
        if (permissionHook.isUserSystemAdmin()) {
            isDisableIRB = false
        }

        return isDisableIRB
    }

    const getDisableUserGroup = () => {
        let isDisableUserGroup = false
        if (groupID === ConstantUserGroup.researcher.toString()) {
            isDisableUserGroup = true
        }

        return isDisableUserGroup
    }

    const openHistoryUpload = () => {
        history.push(`/officer/fileHistory/${params.id}`)
    }

    useEffect(() => {
        const listFile = officerInfo?.documentInfo[0].uploadFileObj.fileList.filter(
            (item) => item.replaceFileID !== null,
        )
        setLstFileUpload(listFile)
    }, [officerInfo?.documentInfo])
    return (
        <FinalForm
            onSubmit={onClickSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={{ ...initialValue, documentInfo: initialUploadFile }}
            validate={validateForm}
        >
            {({ handleSubmit, form, values }) => {
                const handleChangeTitleID = (val: string) => {
                    if (val !== '5') {
                        form.change('titleOtherTH', '')
                        form.change('titleOtherEN', '')
                    }
                }
                const handleChangePositionID = (val: string) => {
                    if (val !== '6') {
                        form.change('positionOtherTH', '')
                        form.change('positionOtherEN', '')
                    }
                }
                return (
                    <div className={classes.divStyle}>
                        <Grid container spacing={2} className={classes.root}>
                            <Grid item xs={12}>
                                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                                    {translate.get('UM.USERGROUP.HEADER')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    name="usergroupID"
                                    option={_.unionWith(lookupUserGroup, lookupUserGroupInitial, _.isEqual)}
                                    label={translate.get('UM.USERGROUP-ADD.USERGROUP')}
                                    placeholder={translate.get('UM.USERGROUP-ADD.USERGROUP')}
                                    size="medium"
                                    defaultValue={groupID}
                                    disabled={getDisableUserGroup()}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    name="irb"
                                    option={lookupGroup}
                                    label={translate.get('UM.USERGROUP-ADD.GROUP')}
                                    placeholder={translate.get('UM.USERGROUP-ADD.GROUP')}
                                    size="medium"
                                    required
                                    disabled={getDisableIRB()}
                                    defaultValue={userIRB ? [userIRB] : undefined}
                                />
                            </Grid>
                            <Grid item className={classes.checkboxDoctor} xs={12}>
                                <MyCheckbox name="isBothIrb" label={translate.get('UM.USERGROUP-ADD.READ_BOTH_IRB')} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                                    {translate.get('UM.USERGROUP-ADD.PROFILE')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Radio
                                    name="cunetID"
                                    labelGroup={translate.get('UM.USERGROUP-ADD.TYPE_ACCOUNT')}
                                    options={[
                                        { id: '1', name: 'CU-NET' },
                                        { id: '2', name: translate.get('UM.USERGROUP-ADD.EXTERNAL') },
                                    ]}
                                    onChangeValue={() => onchangeRadioCUNET && onchangeRadioCUNET(form)}
                                    requiredHalfWidth={true}
                                    disabled={mode === 'edit'}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="username"
                                    materialInputProps={{
                                        label: translate.get('UM.USERGROUP-ADD.EMAIL'),
                                        disabled: readonly || mode === 'edit',
                                        placeholder: translate.get('UM.USERGROUP-ADD.EMAIL'),
                                        size: 'medium',
                                    }}
                                    required
                                    icon={
                                        <IconButton size="small">
                                            {isChecked === null || readonly || mode === 'edit' ? null : isChecked ? (
                                                <Check style={{ fontSize: '1.5rem', color: 'green' }} />
                                            ) : (
                                                <Clear style={{ fontSize: '1.5rem', color: 'red' }} />
                                            )}
                                        </IconButton>
                                    }
                                    handleValueChange={(value) => {
                                        const result = spellWord(value)
                                        form.change('username', result)
                                        onChangeUsername && onChangeUsername()
                                    }}
                                />
                            </Grid>
                            {!(readonly || mode === 'edit') && (
                                <Grid item xs={12} sm={6} className={classes.buttonEmail}>
                                    <Button
                                        size={'large'}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => onCheck && onCheck(values.username, values.cunetID)}
                                    >
                                        {translate.get('UM.EXTERNAL-REGISTER.CHECK')}
                                    </Button>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="email"
                                    materialInputProps={{
                                        label: `${translate.get('UM.PROFILE.EMAIL')} (${translate.get(
                                            'UM.PROFILE.FOR_NEW_ALERT',
                                        )})`,
                                        placeholder: `${translate.get('UM.PROFILE.EMAIL')}`,
                                        size: 'small',
                                    }}
                                    validates={[validateEmail(translate.get('MESSAGE.M017'))]}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                <Select
                                    name="positionID"
                                    option={[...lookupPosition]}
                                    label={translate.get('UM.USERGROUP-ADD.POSITION')}
                                    placeholder={translate.get('UM.USERGROUP-ADD.POSITION')}
                                    size="medium"
                                    required
                                    disabled={readonly}
                                    defaultValue={positionID}
                                    icon={
                                        <Tooltip
                                            title={translate.get('MESSAGE.M024', [
                                                translate.get('UM.USERGROUP-ADD.DOCTOR'),
                                            ])}
                                        >
                                            <IconButton size="small">
                                                <InfoOutlined style={{ fontSize: '18px' }}></InfoOutlined>
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    onChangeSelect={handleChangePositionID}
                                />
                            </Grid>

                            <FieldObservable<string> name="positionID">
                                {({ input }) => {
                                    const positionDisable = input.value !== '6'
                                    return (
                                        <>
                                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                                <MyTextfield
                                                    name="positionOtherTH"
                                                    materialInputProps={{
                                                        label: translate.get('UM.USERGROUP-ADD.OTHER_DESCRIPTION_TH'),
                                                        disabled: positionDisable || readonly,
                                                        placeholder: translate.get(
                                                            'UM.USERGROUP-ADD.OTHER_DESCRIPTION_TH',
                                                        ),
                                                        size: 'medium',
                                                    }}
                                                    required={!positionDisable}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                                <MyTextfield
                                                    name="positionOtherEN"
                                                    materialInputProps={{
                                                        label: translate.get('UM.USERGROUP-ADD.OTHER_DESCRIPTION_EN'),
                                                        disabled: positionDisable || readonly,
                                                        placeholder: translate.get(
                                                            'UM.USERGROUP-ADD.OTHER_DESCRIPTION_EN',
                                                        ),
                                                        size: 'medium',
                                                    }}
                                                    required={!positionDisable}
                                                />
                                            </Grid>
                                        </>
                                    )
                                }}
                            </FieldObservable>

                            <Grid item className={classes.checkboxDoctor} xs={12}>
                                <MyCheckbox
                                    name="isPhD"
                                    label={translate.get('UM.USERGROUP-ADD.DOCTOR')}
                                    disabled={readonly}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                <Select
                                    name="titleID"
                                    option={[...lookupTitleName]}
                                    label={translate.get('UM.USERGROUP-ADD.NAME_TITLE')}
                                    placeholder={translate.get('UM.USERGROUP-ADD.NAME_TITLE')}
                                    size="medium"
                                    disabled={readonly}
                                    defaultValue={titleID}
                                    icon={
                                        <Tooltip title={translate.get('MESSAGE.M025')}>
                                            <IconButton size="small">
                                                <InfoOutlined style={{ fontSize: '18px' }}></InfoOutlined>
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    onChangeSelect={handleChangeTitleID}
                                />
                            </Grid>

                            <FieldObservable<string> name="titleID">
                                {({ input }) => {
                                    const nameTitleDisable = input.value !== '5'
                                    return (
                                        <>
                                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                                <MyTextfield
                                                    name="titleOtherTH"
                                                    materialInputProps={{
                                                        label: translate.get('UM.USERGROUP-ADD.NAME_OTHER_TITLE_TH'),
                                                        disabled: nameTitleDisable || readonly,
                                                        placeholder: translate.get(
                                                            'UM.USERGROUP-ADD.NAME_OTHER_TITLE_TH',
                                                        ),
                                                        size: 'medium',
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                                <MyTextfield
                                                    name="titleOtherEN"
                                                    materialInputProps={{
                                                        label: translate.get('UM.USERGROUP-ADD.NAME_OTHER_TITLE_EN'),
                                                        disabled: nameTitleDisable || readonly,
                                                        placeholder: translate.get(
                                                            'UM.USERGROUP-ADD.NAME_OTHER_TITLE_EN',
                                                        ),
                                                        size: 'medium',
                                                    }}
                                                />
                                            </Grid>
                                        </>
                                    )
                                }}
                            </FieldObservable>

                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="nameTH"
                                    materialInputProps={{
                                        label: translate.get('UM.USERGROUP-ADD.FULLNAME_TH'),
                                        disabled: readonly,
                                        placeholder: translate.get('UM.USERGROUP-ADD.FULLNAME_TH'),
                                        size: 'medium',
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="nameEN"
                                    materialInputProps={{
                                        label: translate.get('UM.USERGROUP-ADD.FULLNAME_EN'),
                                        disabled: readonly,
                                        placeholder: translate.get('UM.USERGROUP-ADD.FULLNAME_EN'),
                                        size: 'medium',
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="homeTelephone"
                                    materialInputProps={{
                                        label: translate.get('UM.USERGROUP-ADD.TELEPHONE_HOME'),
                                        disabled: readonly,
                                        placeholder: translate.get('UM.USERGROUP-ADD.TELEPHONE_HOME'),
                                        size: 'medium',
                                    }}
                                    handleValueChange={(value) =>
                                        onChangeMobilePhone(value, (valBack) => {
                                            form.change('homeTelephone', valBack)
                                        })
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="mobilePhone"
                                    materialInputProps={{
                                        label: translate.get('UM.USERGROUP-ADD.TELEPHONE_MOBILE'),
                                        disabled: readonly,
                                        placeholder: translate.get('UM.USERGROUP-ADD.TELEPHONE_MOBILE'),
                                        size: 'medium',
                                    }}
                                    handleValueChange={(value) =>
                                        onChangeMobilePhone(value, (valBack) => {
                                            form.change('mobilePhone', valBack)
                                        })
                                    }
                                />
                            </Grid>
                            {(Number(values.usergroupID) === 3 ||
                                Number(values.usergroupID) === 6 ||
                                Number(values.usergroupID) === 7) && (
                                <>
                                    <Grid item xs={12}>
                                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                                            {translate.get('UM.UPLOAD.HEADER2')}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <UploadLogo initialValue={initialValue} form={form} />
                                    </Grid>
                                </>
                            )}
                        </Grid>

                        {mode === 'edit' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                                        {translate.get('BUTTON.RESET_PASSWORD')}
                                    </Typography>
                                    <pre />
                                </Grid>
                                <DialogSetPassword />
                            </>
                        )}
                        <Grid container item xs={12} className={classes.containerUpload}>
                            <Typography variant="h6" className={classes.uploadTitle}>
                                {translate.get('LABEL.UPLOAD_FILES')}
                            </Typography>

                            <Typography variant="body1" className={classes.uploadDescription}>
                                ({translate.get('ALERT.CONTENT.UPLOAD_PDF_AT_LEAST_1_FILE')})
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <UploadDocFile
                                name="documentInfo"
                                documentTitleList={topicInitial}
                                accept={'.pdf'}
                                initialData={initialUploadFile as any}
                            />
                        </Grid>
                        {lstFileUpload?.length > 0 && (
                            <Grid container spacing={2} justify="flex-end">
                                <Grid item>
                                    <Typography
                                        className={classes.linkLabel}
                                        onClick={openHistoryUpload}
                                        variant="body2"
                                    >
                                        {translate.get('UM.USERGROUP.OFFICER.UPLOAD-HISTORY')}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}

                        <Grid container justify="flex-end" spacing={2} className={classes.root}>
                            <Grid item>
                                <Button
                                    size={'large'}
                                    variant="contained"
                                    className={classes.cancelButton}
                                    onClick={onClickBackLink}
                                >
                                    {translate.get('BUTTON.CANCEL')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    size={'large'}
                                    variant="contained"
                                    color="primary"
                                    className={classes.saveButton}
                                    style={{ minWidth: '0px' }}
                                    onClick={handleSubmit}
                                >
                                    {translate.get('BUTTON.SAVE')}
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                )
            }}
        </FinalForm>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        padding: '1rem 0px',
    },
    link: {
        color: '#0022FF',
        cursor: 'pointer',
    },
    rootLink: {
        alignSelf: 'center',
    },
    buttonEmail: {
        alignSelf: 'flex-end',
        marginBottom: '16px',
    },
    checkboxDoctor: {
        alignSelf: 'flex-end',
        marginBottom: '8px',
    },
    container: {
        padding: '24px',
        borderRadius: '8px',
    },
    divStyle: {
        margin: '0px 24px',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
    saveButton: {
        border: 'solid 1px #db5f8e',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
    containerUpload: {
        marginTop: '25px',
    },
    uploadTitle: {
        fontWeight: 'bold',
    },
    uploadDescription: {
        color: 'red',
        paddingTop: '5px',
        paddingLeft: '10px',
    },
    linkLabel: {
        textDecoration: 'underline',
        color: '#0062FF',
        cursor: 'pointer',
    },
}))

export default Form
